<div class="toggle-row" [class.disabled]="disabled" [class.on]="checked">
  <div class="toggle-row-head">
    <div *ngIf="icon" class="toggle-icon-tile" [ngStyle]="iconTileStyle">
      <i [class]="icon"></i>
    </div>
    <div class="toggle-text">
      <div class="toggle-title">{{ title }}</div>
      <div *ngIf="subtitle" class="toggle-subtitle">{{ subtitle }}</div>
    </div>
    <button
      type="button"
      class="toggle-switch"
      role="switch"
      [attr.aria-checked]="checked"
      [class.checked]="checked"
      [class.locked]="mandatory"
      [disabled]="disabled || mandatory"
      [ngStyle]="trackStyle"
      (click)="toggle()">
      <span class="toggle-knob"></span>
    </button>
  </div>
  <!-- Subrow holds the revealed input (TCK/SMS). Mandatory rows are locked-on
       informational cards with no projected content, so skip the bordered
       subrow to avoid an empty divider line. -->
  <div class="toggle-subrow" *ngIf="checked && !mandatory">
    <ng-content></ng-content>
  </div>
</div>
